import { render, staticRenderFns } from "./LivePlayerInformation.vue?vue&type=template&id=fc1d26f2"
import script from "./LivePlayerInformation.js?vue&type=script&lang=js&external"
export * from "./LivePlayerInformation.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports